import { useQuery } from "react-query"
import { RequestParameters, ValidateData } from "./interface"
import { AxiosError } from "axios"
import { getValidateData } from "./service"

const VALIDATE_DATA_QUERY = "validateDataQuery"

const validateFilters = (filters: RequestParameters): boolean => {
	const {
		departments,
		categories,
		previousFrom = "",
		previousTo = "",
		currentFrom = "",
		currentTo = "",
		vendors,
	} = filters
	return [
		departments,
		categories,
		vendors,
		previousFrom,
		previousTo,
		currentFrom,
		currentTo,
	].every(isNotEmpty)
}

const isNotEmpty = (text: string) => text?.length > 0

export const useGetValidateData = (filters: RequestParameters) => {
	const {
		isLoading: isPendingRequest,
		data,
		isError,
		error,
		refetch,
		isSuccess,
		isIdle,
	} = useQuery<ValidateData, AxiosError>(
		[VALIDATE_DATA_QUERY, filters],
		() => getValidateData(filters),
		{
			enabled: validateFilters(filters),
			retry: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		}
	)
	return {
		isPendingRequest,
		data,
		isError,
		error,
		refetch,
		isSuccess,
		isIdle,
	}
}
